import { types, Instance } from 'mobx-state-tree';
import { ILocation } from 'types/common';
import { FormName, IOpenPopup, IOrganiserPopUpImage } from './types';

const { model, boolean, maybe, string, frozen } = types;

export const PopUpStore = model('popUpStore', {
  open: maybe(boolean),
  title: maybe(string),
  description: maybe(string),
  buttonLabel: maybe(string),
  formName: maybe(frozen<FormName>()),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callBack: maybe(frozen<{ cb: (...args: any[]) => void }>()),
  popUpImage: maybe(string),
  organiserPopUpImages: maybe(frozen<IOrganiserPopUpImage[]>()),
  location: maybe(frozen<ILocation>()),
}).actions((self) => ({
  setOpen(open: boolean) {
    self.open = open;
  },
  openPopUp({ title, description, buttonLabel, formName, cb }: IOpenPopup): void {
    self.open = true;
    self.title = title;
    self.description = description;
    self.buttonLabel = buttonLabel;
    self.formName = formName;
    if (cb) self.callBack = { cb };
  },
  closePopUp(): void {
    self.open = false;
    self.title = '';
    self.description = '';
    self.buttonLabel = '';
    self.formName = undefined;
    self.callBack = undefined;
    self.location = undefined;
    self.popUpImage = undefined;
    self.organiserPopUpImages = undefined;
  },
  setImageForPopUp(image: string) {
    self.popUpImage = image;
  },
  setLocation(loc: ILocation) {
    self.location = loc;
  },
  setOrganiserPopUpImages(images: IOrganiserPopUpImage[]) {
    self.organiserPopUpImages = images;
  },
}));

export type IPopUpStore = Instance<typeof PopUpStore>;
